import React, { useState, useEffect } from "react";

import FeaturedSettings from "../featured-items/FeaturedSettings";

import { useAppSelector } from "../../../redux/hooks";
import { getAuthToken } from "../../../redux/reducers/auth";

import { RequestState } from "../../../utils/RequestState";
import {
  useGetFacilityAdmin,
  useUpdateFeaturedFacilities,
  useGetRecommendFacilities,
} from "../../../utils/useFacility";
import { PageVisibility } from "../../../utils/PageVisibility";

const FeaturedFacilitySettingsContainer: React.FC = () => {
  const authToken = useAppSelector(getAuthToken);

  const [featuredItems, setFeaturedItems] = useState<
    Array<{ id: string; name: string; status: string }>
  >([]);
  const [sentence, setSentence] = useState<string>("");
  const [requestState, setRequestState] = useState<RequestState>(
    RequestState.Waiting
  );

  const {
    items: { entries: facilityData, sentence: sentenceData },
    isLoading,
  } = useGetRecommendFacilities();

  const {
    items: { facilities },
  } = useGetFacilityAdmin({ authToken, per: -1, status: PageVisibility.PubliclyVisible });

  const { mutateAsync: update, mutateLoading } = useUpdateFeaturedFacilities();

  useEffect(() => {
    if (isLoading) return;

    const facilities: Array<{ id: string; name: string; status: string }> = [];

    for (const facility of facilityData) {
      facilities.push({
        id: facility.id,
        name: facility.name,
        status: facility.status,
      });
    }

    setFeaturedItems([...facilities]);
    setSentence(sentenceData);
  }, [isLoading]);

  const handleChange = (index: number, value: string) => {
    const item = facilities.find(({ name }) => name == value);
    if (item) {
      if (featuredItems.find(({ id }) => id == item.id)) {
        //TODO: Show error
      }

      const newItem = {
        id: item.id,
        name: item.name,
        status: item.status,
      };

      const fItems = featuredItems;
      fItems[index] = newItem;
      setFeaturedItems([...fItems]);
      setRequestState(RequestState.Pending);
    } else {
      const newItem = { id: "", name: value, status: "" };

      const fItems = featuredItems;
      fItems[index] = newItem;
      setFeaturedItems([...fItems]);
      setRequestState(RequestState.Pending);
    }
    return false;
  };

  const handleTitle = (value: string) => {
    setSentence(value);
  };

  const addItem = () => {
    const fItems = featuredItems;

    fItems.push({ id: "", name: "", status: "" });
    setFeaturedItems([...fItems]);
  };

  const removeItem = (index: number) => {
    const fItems = featuredItems;

    fItems.splice(index, 1);
    setFeaturedItems([...fItems]);
  };

  const handleSubmit = async () => {
    if (authToken) {
      setRequestState(RequestState.Doing);

      const ids: Array<string> = [];

      for (const item of featuredItems) {
        ids.push(item.id);
      }

      await update({ authToken, ids, sentence });

      setRequestState(RequestState.Success);
    }
  };

  return (
    <FeaturedSettings
      target="施設"
      name="facility"
      id="Facilities"
      contentTitleLabel="イチオシ施設説明"
      isLoading={isLoading || mutateLoading}
      options={facilities.map((f) => f.name)}
      selectedItems={featuredItems}
      featuredTitle={sentence}
      requestState={requestState}
      addItem={addItem}
      removeItem={removeItem}
      handleChange={handleChange}
      handleTitle={handleTitle}
      handleSubmit={handleSubmit}
    />
  );
};

export default FeaturedFacilitySettingsContainer;
